import { render, staticRenderFns } from "./PricingTabs.vue?vue&type=template&id=62c3662a&"
import script from "./PricingTabs.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PricingTabs.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PricingTabs.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports